<template>
    <div class="map-area">
        <div class="container-fluid">
            <div class="card-box-style map-style-one mb-24">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d284603.387820268!2d-2.808959603107038!3d54.99735900922555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x25a3b1142c791a9%3A0xc4f8a0433288257a!2sUnited%20Kingdom!5e0!3m2!1sen!2sbd!4v1664342734415!5m2!1sen!2sbd"></iframe>
            </div>
            <div class="card-box-style map-style-two mb-24">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d357405.5974223297!2d-2.808959603107038!3d54.99735900922555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x25a3b1142c791a9%3A0xc4f8a0433288257a!2sUnited%20Kingdom!5e1!3m2!1sen!2sbd!4v1664342999936!5m2!1sen!2sbd"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MapContent'
}
</script>

<style lang="scss">
.map-style-one {
	iframe {
		width: 100%;
		border-radius: 10px;
		height: 600px;
	}
}
.map-style-two {
	iframe {
		width: 100%;
		border-radius: 10px;
		height: 600px;
	}
}
</style>